import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {BannerModule} from '../shared/modules/banner/banner.module';
import {SafeHtmlModule} from '../shared/pipes/safe-html/safe-html.module';
import {CarouselFtdModule} from '../shared/modules/carousel-ftd/carousel-ftd.module';
import {IconsModule} from '../shared/modules/icons/icons.module';
import {ProviderGeneralComponent} from './provider-general.component';
import {ProviderGeneralRoutingModule} from './provider-general.routing';
import {LoadingModule} from '../shared/modules/loading/loading.module';

@NgModule({
  declarations: [ProviderGeneralComponent],
  imports: [
    CommonModule,
    BannerModule,
    ProviderGeneralRoutingModule,
    SafeHtmlModule,
    VirtualScrollerModule,
    CarouselFtdModule,
    IconsModule,
    LoadingModule,
  ],
  exports: [ProviderGeneralComponent],
})
export class ProviderGeneralModule { }
